import WinnerBanner from './WinnerBanner';

export default WinnerBanner;
